
const attribution = require('./attribution');

module.exports = prefix => ({
  id: `${prefix}`,
  question: 'What Channel was it from?',
  type: 'input',
  attribution: attribution.UTM,
});
